module.exports = __webpack_public_path__ + "static/media/branding.9be09581.svg";